<template>
  <div id="manageAirport" class="Content-Page">
    <div id="namePage" class="wrap-Main">
      <div class="box-S4 flex-between-center">
        <div class="N-Page T-size-36">Manage Airport</div>
        <v-btn class="theme-btn-even" @click.stop="addItem()">
          <span class="I-create"></span>
          <span>Add Airport</span>
        </v-btn>
      </div>
    </div>    

    <div id="tableData" class="wrap-Main">
      <div class="box-S4">
        <v-data-table :headers="headers" :items="items">
          <template v-slot:item.ap_name="{ item }">
            <v-chip :color="item.ap_color">{{ item.ap_name }}</v-chip>
          </template>
          <template v-slot:item.ap_image_url="{ item }">
            <img class="B-img-airport" :src="item.ap_image_url" />
          </template>
          <template v-slot:item.ap_activity="{ item }">
            <v-icon v-if="item.ap_activity == true">mdi-check</v-icon>
            <v-icon v-else>mdi-close</v-icon>
          </template>
          <template v-slot:item.action="{ item }" class="text-xs-right">
            <div class="b-action">
              <div class="b-btn">
                <v-btn fab class="btn-edit" @click="editItem(item)">
                  <span class="I-edit"></span>
                </v-btn>
                <v-btn fab class="primary btn-delete" @click="deleteItem(item)">
                  <span class="I-bin"></span>
                </v-btn>
              </div>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <!-- dialog สำหรับ เพิ่ม แก้ไข -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <!-- set form กรอกข้อมูลที่นี้ -->
              <v-flex sm12 xs12 md12 lg12>
                <v-text-field v-model="formModel.ap_name" label="Name"></v-text-field>
              </v-flex>

              <v-flex sm10 xs10 md10 lg10>
                <v-text-field v-model="formModel.ap_color" label="Color"></v-text-field>
              </v-flex>
              <v-flex sm2 xs2 md2 lg2>
                <v-checkbox v-model="formModel.ap_activity" label="Activity"></v-checkbox>
              </v-flex>

              <v-flex sm6 xs6 md6 lg6>
                <v-text-field v-model="formModel.ap_lat" label="lat"></v-text-field>
              </v-flex>

              <v-flex sm6 xs6 md6 lg6>
                <v-text-field v-model="formModel.ap_lng" label="long"></v-text-field>
              </v-flex>

              <v-flex xs12>
                Image
                <uploadform @success="uploadDone">
                  <div slot="activator">
                    <v-flex xs12 text-xs-center>
                      <v-img :aspect-ratio="4/3" :src="formModel.ap_image_url" max-width="500"></v-img>
                    </v-flex>
                  </div>
                </uploadform>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn :loading="loading" @click="saveToServer">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog สำหรับลบ -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Confirmation</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex>Delete "{{formModel[Object.keys(formModel)[1]]}}" ?</v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn :loading="loading" @click="deleteToServer">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="partBack" class="wrap-Main">
      <div class="line"></div>
      <div class="box-S4">
        <v-btn text class="ColorTheme-S white--text theme-btn" @click="Back()">
          <span class="I-back"></span>
          <span>Back</span>
        </v-btn>
      </div>
    </div>

  </div>
</template>


<script>
import feathersClientUOA from "../plugins/feathers-client-uoa";
import upload from "../utils/upload";
import uploadform from "../components/upload/ImageInput.vue";

export default {
  data: () => ({
    headers: [
      { value: "ap_name", text: "Name", sortable: true },
      { value: "ap_lat", text: "Lat", sortable: true },
      { value: "ap_lng", text: "Long", sortable: true },
      { value: "ap_image_url", text: "Image", sortable: true },
      { value: "ap_activity", text: "Activity", sortable: true },
      { value: "action", text: "", sortable: false }
    ],
    defaultValue: {
      ap_name: "",
      ap_color: "",
      ap_lat: "",
      ap_image_url: "/img/AAA.png",
      ap_lng: "",
      ap_activity: null
    },
    //--end config

    items: [],
    loading: false,
    dialog: false,
    dialogDelete: false,
    formModel: {},
    mode: "" // มีได้ 2 แบบคือ create กับ edit
  }),
  components: {
    uploadform
  },
  computed: {
    formTitle() {
      return this.mode === "create" ? "Add" : "Edit";
    }
  },
  async mounted() {
    //init here
    this.renderUI();
  },
  methods: {
    Back() {
      this.$router.go(-1);
    },
    async renderUI() {
      try {
        const q = {};
        q.retire = 0;
        var res = await feathersClientUOA
          .service("airports")
          .find({ query: q });
        this.items = res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async addItem() {
      this.mode = "create";
      this.formModel = Object.assign({}, this.defaultValue);
      this.dialog = true;
    },

    async editItem(item) {
      this.mode = "edit";
      this.formModel = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      this.formModel = Object.assign({}, item);
      this.dialogDelete = true;
    },

    closeDialog() {
      this.dialog = false;
      this.dialogDelete = false;
    },
    async saveToServer() {
      // const valid = await this.$validator.validateAll();
      // if (!valid) {
      //   return;
      // }
      let activity = "";
      if (this.formModel.ap_activity == true) {
        activity = "1";
      } else {
        activity = "0";
      }
      this.loading = true;
      if (this.mode === "edit") {
        try {
          let dataEdit = {
            ap_name: this.formModel.ap_name,
            ap_color: this.formModel.ap_color,
            ap_lat: this.formModel.ap_lat,
            ap_lng: this.formModel.ap_lng,
            ap_image_url: this.formModel.ap_image_url,
            ap_activity: activity,
            mb: "GEM 2",
            md: new Date()
          };
          await feathersClientUOA
            .service("airports")
            .patch(this.formModel.ap_id, dataEdit);
          this.renderUI();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      } else {
        //Add Data
        try {
          let dataAdd = {
            ap_name: this.formModel.ap_name,
            ap_color: this.formModel.ap_color,
            ap_lat: this.formModel.ap_lat,
            ap_lng: this.formModel.ap_lng,
            ap_image_url: this.formModel.ap_image_url,
            ap_activity: activity,
            cb: "GEM 2",
            cd: new Date()
          };
          await feathersClientUOA.service("airports").create(dataAdd);
          this.renderUI();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
      this.closeDialog();
    },
    async deleteToServer() {
      this.loading = true;
      try {
        let dataDelete = {
          mb: "GEM 2",
          md: new Date(),
          retire: 1
        };
        await feathersClientUOA
          .service("airports")
          .patch(this.formModel.ap_id, dataDelete);
        this.renderUI();
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        this.dialogDelete = false;
      }
    },
    uploadDone(uploadInfo) {
      this.formModel.ap_image_url = uploadInfo.url;
    }
  }
};
</script>